/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import { m11ResearchStudyResourceChanged, selectM11ResearchStudyResource } from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import jsonEquals from "../../functions/jsonEquals";
import StringEntry from "../../datatypeComponents/StringEntry";
import ArrayEntry from "../../datatypeComponents/ArrayEntry";
import ExpandToAddOrEdit from "../../components/ExpandToAddOrEdit";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveSponsorChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    sponsorState, setAlertModalState, setStartingSponsorState) => {
    let changesStates = {
        sponsorState: sponsorState
    };
    let response = await saveM11Changes(apiToken, 1, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ResearchStudyResource) {
            dispatch(m11ResearchStudyResourceChanged(response.m11ResearchStudyResource));
        }
        setStartingSponsorState(JSON.parse(JSON.stringify(sponsorState)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
}

const CosponsorEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

    const [cosponsorState, setCosponsorState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingCosponsorEntry = { cosponsorName: "", cosponsorAddress: "" };
        if (startingValue?.cosponsorName) {
            startingCosponsorEntry.cosponsorName = startingValue.cosponsorName;
        }
        if (startingValue?.cosponsorAddress) {
            startingCosponsorEntry.cosponsorAddress = startingValue.cosponsorAddress;
        }
        setCosponsorState(JSON.parse(JSON.stringify(startingCosponsorEntry)));
    }, []);

    useEffect(() => {
        if (Object.keys(cosponsorState).length > 0) {
            let newCosponsorEntry = {};
            if (cosponsorState.cosponsorName) {
                newCosponsorEntry.cosponsorName = cosponsorState.cosponsorName;
            }
            if (cosponsorState.cosponsorAddress) {
                newCosponsorEntry.cosponsorAddress = cosponsorState.cosponsorAddress;
            }
            if (Object.keys(newCosponsorEntry).length === 0) {
                newCosponsorEntry = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newCosponsorEntry }; });
        }
    }, [cosponsorState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                {startingValue.cosponsorName && <p><b>Co-Sponsor Name: </b>{startingValue.cosponsorName}</p>}
                {startingValue.cosponsorAddress && <p><b>Co-Sponsor Legal Address: </b>{startingValue.cosponsorAddress}</p>}
            </div >}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(cosponsorState).length > 0) {
        return <div>
            <b>{fieldLabel}: </b>
            <div style={{ marginLeft: "24px" }}>
                <StringEntry elementName='cosponsorName'
                    fieldLabel='Co-Sponsor Name'
                    startingValue={cosponsorState.cosponsorName}
                    setResourceState={setCosponsorState} />
                <StringEntry elementName='cosponsorAddress'
                    fieldLabel='Co-Sponsor Legal Address'
                    startingValue={cosponsorState.cosponsorAddress}
                    setResourceState={setCosponsorState} />
            </div>
        </div>
    }
};

const LocalSponsorEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

    const [localSponsorState, setLocalSponsorState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingLocalSponsorEntry = { localSponsorName: "", localSponsorAddress: "" };
        if (startingValue?.localSponsorName) {
            startingLocalSponsorEntry.localSponsorName = startingValue.localSponsorName;
        }
        if (startingValue?.localSponsorAddress) {
            startingLocalSponsorEntry.localSponsorAddress = startingValue.localSponsorAddress;
        }
        setLocalSponsorState(JSON.parse(JSON.stringify(startingLocalSponsorEntry)));
    }, []);

    useEffect(() => {
        if (Object.keys(localSponsorState).length > 0) {
            let newLocalSponsorEntry = {};
            if (localSponsorState.localSponsorName) {
                newLocalSponsorEntry.localSponsorName = localSponsorState.localSponsorName;
            }
            if (localSponsorState.localSponsorAddress) {
                newLocalSponsorEntry.localSponsorAddress = localSponsorState.localSponsorAddress;
            }
            if (Object.keys(newLocalSponsorEntry).length === 0) {
                newLocalSponsorEntry = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newLocalSponsorEntry }; });
        }
    }, [localSponsorState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                {startingValue.localSponsorName && <p><b>Local Sponsor Name: </b>{startingValue.localSponsorName}</p>}
                {startingValue.localSponsorAddress && <p><b>Local Sponsor Legal Address: </b>{startingValue.localSponsorAddress}</p>}
            </div >}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(localSponsorState).length > 0) {
        return <div>
            <b>{fieldLabel}: </b>
            <div style={{ marginLeft: "24px" }}>
                <StringEntry elementName='localSponsorName'
                    fieldLabel='Local Sponsor Name'
                    startingValue={localSponsorState.localSponsorName}
                    setResourceState={setLocalSponsorState} />
                <StringEntry elementName='localSponsorAddress'
                    fieldLabel='Local Sponsor Legal Address'
                    startingValue={localSponsorState.localSponsorAddress}
                    setResourceState={setLocalSponsorState} />
            </div>
        </div>
    }
};

const DeviceManufacturerEntry = ({ elementName, fieldLabel, startingValue, setResourceState, startCollapsed }) => {

    const [deviceManufacturerState, setDeviceManufacturerState] = useState({});
    const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

    useEffect(() => {
        let startingDeviceManufacturerEntry = { deviceManufacturerName: "", deviceManufacturerAddress: "" };
        if (startingValue?.deviceManufacturerName) {
            startingDeviceManufacturerEntry.deviceManufacturerName = startingValue.deviceManufacturerName;
        }
        if (startingValue?.deviceManufacturerAddress) {
            startingDeviceManufacturerEntry.deviceManufacturerAddress = startingValue.deviceManufacturerAddress;
        }
        setDeviceManufacturerState(JSON.parse(JSON.stringify(startingDeviceManufacturerEntry)));
    }, []);

    useEffect(() => {
        if (Object.keys(deviceManufacturerState).length > 0) {
            let newDeviceManufacturerEntry = {};
            if (deviceManufacturerState.deviceManufacturerName) {
                newDeviceManufacturerEntry.deviceManufacturerName = deviceManufacturerState.deviceManufacturerName;
            }
            if (deviceManufacturerState.deviceManufacturerAddress) {
                newDeviceManufacturerEntry.deviceManufacturerAddress = deviceManufacturerState.deviceManufacturerAddress;
            }
            if (Object.keys(newDeviceManufacturerEntry).length === 0) {
                newDeviceManufacturerEntry = null;
            }
            setResourceState(prevState => { return { ...prevState, [elementName]: newDeviceManufacturerEntry }; });
        }
    }, [deviceManufacturerState]);

    if (startCollapsedState) {
        return <div>
            <b>{fieldLabel}: </b>
            {startingValue && <div style={{ marginLeft: "24px" }}>
                {startingValue.deviceManufacturerName && <p><b>Device Manufacturer Name: </b>{startingValue.deviceManufacturerName}</p>}
                {startingValue.deviceManufacturerAddress && <p><b>Device Manufacturer Legal Address: </b>{startingValue.deviceManufacturerAddress}</p>}
            </div >}
            &nbsp;&nbsp;
            <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
        </div>
    } else if (Object.keys(deviceManufacturerState).length > 0) {
        return <div>
            <b>{fieldLabel}: </b>
            <div style={{ marginLeft: "24px" }}>
                <StringEntry elementName='deviceManufacturerName'
                    fieldLabel='Device Manufacturer Name'
                    startingValue={deviceManufacturerState.deviceManufacturerName}
                    setResourceState={setDeviceManufacturerState} />
                <StringEntry elementName='deviceManufacturerAddress'
                    fieldLabel='Device Manufacturer Legal Address'
                    startingValue={deviceManufacturerState.deviceManufacturerAddress}
                    setResourceState={setDeviceManufacturerState} />
            </div>
        </div>
    }
};

const M11Step001SponsorDetails = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [sponsorState, setSponsorState] = useState({
        "sponsorName": "", "sponsorAddress": "",
        "cosponsors": [], "localSponsors": [], "manufacturers": [],
        "medicalExpertContact": "", "sponsorConfidentialityStatement": ""
    });
    const [startingSponsorState, setStartingSponsorState] = useState({
        "sponsorName": "", "sponsorAddress": "",
        "cosponsors": [], "localSponsors": [], "manufacturers": [],
        "medicalExpertContact": "", "sponsorConfidentialityStatement": ""
    });

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(sponsorState, startingSponsorState)),
        async saveAllChanges() {
            await saveSponsorChanges(dispatch, apiToken, m11ResearchStudyFoi,
                sponsorState, setAlertModalState, setStartingSponsorState);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource) {
            let startingSponsorDetails = {
                "sponsorName": "", "sponsorAddress": "",
                "cosponsors": [], "localSponsors": [], "manufacturers": [],
                "medicalExpertContact": "", "sponsorConfidentialityStatement": ""
            };
            if (m11ResearchStudyResource.associatedParty) {
                for (const associated of m11ResearchStudyResource.associatedParty) {
                    if (associated.role?.coding?.[0]?.code === "lead-sponsor") {
                        startingSponsorDetails.sponsorName = associated.name;
                        startingSponsorDetails.sponsorAddress = associated.party?.display;
                    } else if (associated.role?.coding?.[0]?.code === "sponsor") {
                        if (associated.role.text?.toLowerCase() === "co-sponsor" ||
                            associated.role.text?.toLowerCase() === "cosponsor") {
                            startingSponsorDetails.cosponsors.push({
                                cosponsorName: associated.name,
                                cosponsorAddress: associated.party?.display
                            });
                        } else if (associated.role.text?.toLowerCase() === "local sponsor") {
                            startingSponsorDetails.localSponsors.push({
                                localSponsorName: associated.name,
                                localSponsorAddress: associated.party?.display
                            });
                        } else {
                            startingSponsorDetails.sponsorName = associated.name;
                            startingSponsorDetails.sponsorAddress = associated.party?.display;
                        }
                    } else if (associated.role.text?.toLowerCase() === "device manufacturer") {
                        startingSponsorDetails.manufacturers.push({
                            deviceManufacturerName: associated.name,
                            deviceManufacturerAddress: associated.party?.display
                        });
                    } else if (associated.role.text?.toLowerCase() === "medical expert contact") {
                        startingSponsorDetails.medicalExpertContact = associated.name;
                    }
                }
            }
            if (m11ResearchStudyResource.extension) {
                for (const extension of m11ResearchStudyResource.extension) {
                    if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-sponsor-confidentiality-statement" &&
                        extension.valueString
                    ) {
                        startingSponsorDetails.sponsorConfidentialityStatement = extension.valueString;
                    }
                }
            }
            startingSponsorDetails.loaded = true;
            setSponsorState(startingSponsorDetails);
            setStartingSponsorState(startingSponsorDetails);
        }
    }, [m11ResearchStudyResource]);

    return <div>
        <div className="h3Style h3EntryLabel" style={{ marginBottom: "0px" }}>
            Enter Sponsor Details for M11ResearchStudy.<span> This will be used for the M11 Report Title Page.</span>
        </div>
        {sponsorState.loaded && <>
            <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}>
                <span>Enter the </span>Sponsor Name<span> and </span>Address<span>.</span>
            </div>
            <StringEntry elementName='sponsorName'
                required={true}
                fieldLabel='Sponsor Name'
                startingValue={sponsorState.sponsorName}
                setResourceState={setSponsorState} />
            <StringEntry elementName='sponsorAddress'
                required={true}
                fieldLabel='Sponsor Legal Address'
                startingValue={sponsorState.sponsorAddress}
                setResourceState={setSponsorState} />
            <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}><span>If applicable, enter the </span>Co-Sponsor Name<span> and </span>Address<span>.</span></div>
            <ArrayEntry datatype="Cosponsor" elementName="cosponsors" fieldLabel="Co-Sponsor"
                startCollapsed={true} startEmptyArrayClosed={true} deletable={true} doNotShowFieldLabel={true}
                startingValue={sponsorState.cosponsors} setResourceState={setSponsorState} />
            <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}><span>If applicable, enter the </span>Local Sponsor Name<span> and </span>Address<span>.</span></div>
            <ArrayEntry datatype="LocalSponsor" elementName="localSponsors" fieldLabel="Local Sponsor"
                startCollapsed={true} startEmptyArrayClosed={true} deletable={true} doNotShowFieldLabel={true}
                startingValue={sponsorState.localSponsors} setResourceState={setSponsorState} />
            <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}><span>If applicable, enter the </span>Device Manufacturer Name<span> and </span>Address<span>.</span></div>
            <ArrayEntry datatype="DeviceManufacturer" elementName="manufacturers"
                fieldLabel="Device Manufacturer" doNotShowFieldLabel={true}
                startCollapsed={true} startEmptyArrayClosed={true} deletable={true}
                startingValue={sponsorState.manufacturers} setResourceState={setSponsorState} />
            <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}><span>If applicable, enter the </span>Medical Expert contact information<span>.</span></div>
            <StringEntry elementName='medicalExpertContact'
                fieldLabel='Medical Expert Contact'
                startingValue={sponsorState.medicalExpertContact}
                setResourceState={setSponsorState} />
            <div className="h4Style h4EntryLabel" style={{ marginBottom: "0px" }}><span>If applicable, enter the </span>Sponsor Confidentiality Statement<span>.</span></div>
            <StringEntry elementName='sponsorConfidentialityStatement'
                fieldLabel='Sponsor Confidentiality Statement'
                startingValue={sponsorState.sponsorConfidentialityStatement}
                setResourceState={setSponsorState} />
        </>}
    </div>
});

const M11Step001SponsorDetailsHelperText = <div>
    <h3>Enter Sponsor Details for M11ResearchStudy</h3>
    <div style={{ textAlign: "left" }}>
        <p>Provide the legal name and address of the individual or pharmaceutical or medical device company, governmental agency, academic institution, private organisation, or other organisation who takes primary responsibility for and initiates a clinical investigation.</p>
        <p>If more than one sponsor, list the primary sponsor in the Sponsor Name and Sponsor Legal Address fields. If co-sponsor is applicable, enter co-sponsor name and legal address. Add additional co-sponsors if more than one co-sponsor is applicable.</p>
        <p>In some countries, the clinical trial sponsor may be the local affiliate company (or designee). In such cases, indicate this in the Local Sponsor Name and Local Sponsor Legal Address Fields.</p>
        <p>Manufacturer name and address information is required only for drug/device combination protocols that include investigational device(s) and should not be included for other protocols. Include the manufacturer address only if the manufacturer is different than the sponsor listed above. Add additional manufacturers as needed if multiple investigational devices will be used in the trial or if there are multiple manufacturers for a single device. Delete this line if not applicable. </p>
        <p>Entering Medical Expert Contact is optional. If used, enter Medical Expert contact information (as designated by sponsor) or enter the location where Medical Expert contact information can be found.</p>
        <p>Entering Sponsor Confidentiality Statement is optional.</p>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step001ValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 1, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 1 (Enter Sponsor Details for M11ResearchStudy) {validationCheckState.step01numberOfChecks} issues checked. {validationCheckState.step01numberPassed} passed. {validationCheckState.step01numberFailed} failed.</h4>
        <p>Sponsor Name has data stored in M11ResearchStudy Resource: {validationCheckState.resultCheckSponsorName}</p>
        <p>Sponsor Legal Address has data stored in M11ResearchStudy Resource: {validationCheckState.resultCheckSponsorAddress}</p>
    </div>}  </div>
}

export default M11Step001SponsorDetails;
export {
    M11Step001SponsorDetailsHelperText, M11Step001ValidationCheck,
    CosponsorEntry, LocalSponsorEntry, DeviceManufacturerEntry
};